import {SET_SHOW_HOBBIES_RESTRICATION,SET_SKILL_DATA,SET_MEMBERSHIP,SET_BADGE_DATA,SET_SPORTS_ACCOMPLISHMENTS,SET_ACCOMPLISHMENTS,TOTAL_CV_DATA,SEARCH_DATA,GRADE_LIST,USER_DATA,SET_USER_DATA,GET_EDUCATION_DATA,SETWORK_EXPERIENCEDATA,SET_COURSES,SET_COURSES_PROJECT,SET_HOBBIES } from '../actions/actionTypes';

const intialState = {
    totalCvData: [],
    usedetailsData: [],
    gradeList: [],
    usernameData: [],
    cardDataQuery1: [],
    getCardItemData: [],   
    work_ExperienceData: [],  
    courses: [],
    projects: [],
    hobbies: [],
    accomplishments: [],
    sportsaccomplishments: [],
    badges:[],
    membership:[],
    skillData:[],
    error:null,
  };
  
  export const cvReducer = (state = intialState, { type, cvData, usedetailsData }) => {
    switch (type) {    
     case TOTAL_CV_DATA:
        return {
                ...state, 
                totalCvData: cvData,
                usedetailsData: usedetailsData,
                error:null,
           }; 
     case SEARCH_DATA:
               return {
                       ...state, 
                       totalCvData: cvData,
                       usedetailsData: usedetailsData,
                       error:null,
                  };
     case GRADE_LIST:
      return {
              ...state, 
              gradeList : cvData,
              error:null,
          };  
      case USER_DATA:
        return {
                ...state, 
                usernameData : cvData,
                error:null,
            };  
      case SET_USER_DATA:
        return {
                ...state, 
                cardDataQuery1 : cvData,
                error:null,
            }; 
      case GET_EDUCATION_DATA:
              return {
                      ...state, 
                      getCardItemData : cvData,
                      error:null,
                  };
      case SETWORK_EXPERIENCEDATA:
        return {
                ...state, 
                work_ExperienceData : cvData,
                error:null,
            };
      case SET_COURSES:
        return {
                ...state, 
                courses : cvData,
                error:null,
            };
      case SET_COURSES_PROJECT:
        return {
                ...state, 
                projects : cvData,
                error:null,
            };
      case SET_HOBBIES:
        return {
                ...state, 
                hobbies : cvData,
                error:null,
            };
      case SET_ACCOMPLISHMENTS:
        return {
                ...state, 
                accomplishments : cvData,
                error:null,
            };
      case SET_SPORTS_ACCOMPLISHMENTS:
        return {
                ...state, 
                sportsaccomplishments : cvData,
                error:null,
            };
      case SET_BADGE_DATA:
      return {
              ...state, 
              badges : cvData,
              error:null,
          };
      case SET_MEMBERSHIP:
            return {
                    ...state, 
                    membership : cvData,
                    error:null,
                };
      case SET_SKILL_DATA:
        return {
                ...state, 
                skillData : cvData,
                error:null,
            };
      case SET_SHOW_HOBBIES_RESTRICATION:
              return {
                      ...state, 
                      showHobbiesRestriction : cvData,
                      error:null,
                  };            
      default:
        return state;
    }
  };
